<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "serve",
  computed: {},
  mounted() {},
  methods: {}
};
</script>
